import { MerchCardLayoutUI } from 'pricing-pages-ui-components/components/merch-card/MerchCardLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicMerchCardLayoutUI = ({
  'data-selenium-id': dataSeleniumId,
  columnStart,
  Title,
  Subheading,
  Pricing,
  BelowPrice,
  Term,
  CTAs,
  BelowCTA,
  Features,
  Footer
}) => {
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-selenium-id": dataSeleniumId,
    columnStart: columnStart,
    Title: Title,
    Subheading: Subheading,
    Pricing: Pricing,
    Seats: BelowPrice,
    Term: Term,
    CTAs: CTAs,
    Credits: BelowCTA,
    Features: Features,
    Footer: Footer
  });
};